const prefixEvent = (event, timing) => {
	const el = document.createElement('el');

	const prefixes = ['webkit', 'moz', 'MS', 'o', ''];
	let events = {};

	for(let prefix of prefixes) {
		events[prefix + event] = prefix + event + timing;
	}

	for(let e in events) {
		if(typeof el.style[e] !== undefined) {
			return events[e];
		}
	}
}

export const BrowserEvents = {

	lazyload: 'lazyload.refresh',

	barba: {
		enter: 'barba.enter',
		leave: 'barba.leave',
		transition: 'barba.transition',
	},

	transition: {
		start: prefixEvent('Transition', 'Start'),
		end: prefixEvent('Transition', 'End'),
	},

	animation: {
		start: prefixEvent('Animation', 'Start'),
		end: prefixEvent('Animation', 'End'),
	}
}

export const MobileBreakpoint = 768;

export const $html = jQuery('html');
export const $body = jQuery('body');
export const menuWrapper = document.getElementById('menu-wrapper');
export const loadingBar = document.querySelector('.loading-bar');
